import React from 'react';
import { useParams } from 'react-router-dom';
import WebhooksEdit from '@components/notification-channel/webhooks/Edit';

const WebhooksEditPage = () => {
  const { id }: any = useParams();

  return <WebhooksEdit id={id} />;
};

export default WebhooksEditPage;
